export class SoilScoutLogin {

    constructor(userName: string, password: string) {
        this.username = userName;
        this.password = password;
    }

    username: string;
    password: string;
}
